/* eslint-disable react/jsx-wrap-multilines */
import { useState } from 'react';
import { Common, color, Widget } from '@stockbit/ui';
import { Modal, InputModal } from '../styled';

const { Text, Flex } = Common;
const { Button } = Widget;

interface ValuationModalCreateTypes {
  isVisible: boolean;
  onCancel: () => void;
  onSubmit: (param: string) => void;
  isLoading: () => void;
}

const ValuationModalCreate = ({
  isVisible,
  onCancel,
  onSubmit,
  isLoading,
}: ValuationModalCreateTypes) => {
  const [valueInput, setValueInput] = useState('');

  const onChangeInput = (e) => {
    const inputed = e.target.value;

    setValueInput(inputed);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const value = valueInput.trim();
    onSubmit(value);
  };

  return (
    <Modal
      title={
        <Text size="18px" align="center" height="40px" family="bold">
          Save New Valuation
        </Text>
      }
      visible={isVisible}
      onCancel={onCancel}
      centered
      footer={null}
    >
      <form onSubmit={handleSubmit}>
        <Text mb="8px">Valuation Name</Text>
        <InputModal placeholder="Valuation Name" onChange={onChangeInput} />
        <Flex justify="flex-end" mt="15px">
          <Button height="40px" htmlType="button" borderLess onClick={onCancel}>
            <Text>CANCEL</Text>
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            height="40px"
            width="80px"
            round
            loading={isLoading}
          >
            <Text color={color.light} align="center">
              {!isLoading && 'SAVE'}
            </Text>
          </Button>
        </Flex>
      </form>
    </Modal>
  );
};

export default ValuationModalCreate;
